<template>
  <div class="page">
    <el-table
      :data="tableData"
      :span-method="objectSpanMethod"
      height="600"
      border
      style="width: 98%; overflow: auto"
    >
      <el-table-column prop="typeName" label="一级分类" width="150">
      </el-table-column>
      <el-table-column prop="typeSubName" label="二级分类" width="150">
      </el-table-column>
      <el-table-column prop="typeThreeName" label="三级分类" width="200">
      </el-table-column>
      <el-table-column prop="keywordList" label="关键字" width="600">
        <template slot-scope="scope">
          <div class="tags">
            <el-tag
              v-for="tag in scope.row.keywordList"
              :key="tag.id"
              :closable="scope.row.chosenClose"
              style="margin: 3px"
              @close="handleCloseTag(scope.row, tag)"
            >
              {{ tag.name }}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="scope.row.inputVisible && scope.row.chosenClose"
              v-model="scope.row.inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm(scope.row)"
              @blur="handleInputConfirm(scope.row)"
            >
            </el-input>
            <el-button
              v-if="!scope.row.inputVisible && scope.row.chosenClose"
              class="button-new-tag"
              size="small"
              @click="scope.row.inputVisible = true"
              >+ 新增关键词</el-button
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button
            @click="scope.row.chosenClose = !scope.row.chosenClose"
            type="text"
            size="small"
            >{{ scope.row.chosenClose ? "取消修改" : "修改" }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div class="edit" @click="handleSave">保存修改</div> -->
  </div>
</template>

<script>
import {
  getArticleKeyword,
  deleteArticleKeyword,
  addArticleKeyword,
} from "@/api/api";
export default {
  data() {
    return {
      tableData: [],
      spanArr: [],
      pos: 0,
      spanArr2: [],
      pos2: 0,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    // 获取表格数据
    getTableData() {
      getArticleKeyword().then((res) => {
        if (res.data.code === 200) {
          let list = this.handleArrangeData(res.data.data);
          list.map((c1) => {
            let keywordList = [];
            c1.childrens.map((item) => {
              keywordList.push({ id: item.id, name: item.name });
            });
            c1.keywordList = keywordList;
          });
          this.tableData = list;
          this.getSpanArr();
        }
      });
    },
    // 删除tag
    async handleCloseTag(row, tag) {
      if (tag.id) {
        const res = await deleteArticleKeyword([{ id: tag.id }]);
        if (res.data.code === 200) {
          this.$message.success(res.data.message || "删除成功");
          this.tableData.map((item) => {
            if (item.id === row.id) {
              item.keywordList = item.keywordList.filter(
                (childTag) => childTag.name !== tag.name
              );
            }
          });
        } else {
          this.$message.error(res.data.message || "删除失败");
        }
      } else {
        this.tableData.map((item) => {
          if (item.id === row.id) {
            item.keywordList = item.keywordList.filter(
              (childTag) => childTag.name !== tag.name
            );
          }
        });
      }
    },
    // 保存修改
    handleSave() {
      console.log(this.tableData);
    },
    // 整理数据已符合表格格式
    handleArrangeData(tableData) {
      let thirdList = [];
      // let cname = tableData[0].name;\
      tableData.map((c1, index) => {
        c1.childrens.map((c2) => {
          c2.childrens.map((item) => {
            thirdList.push({
              ...item,
              typeThree: item.id,
              typeThreeName: item.name,
              type: c1.id,
              typeName: c1.name,
              typeSub: c2.id,
              typeSubName: c2.name,
              chosenClose: false,
              inputVisible: false,
              inputValue: "",
            });
          });
        });
      });
      return thirdList;
    },
    // 添加关键词
    async handleInputConfirm(row) {
      if (row.inputValue.trim() == "") {
        this.tableData.map((item) => {
          if (item.id === row.id) {
            item.inputVisible = false;
            item.inputValue = "";
          }
        });
        return;
      }
      let obj = {
        typeThree: row.id,
        typeThreeName: row.name,
        type: row.id,
        typeName: row.name,
        typeSub: row.id,
        typeSubName: row.name,
        name: row.inputValue,
        status: 1,
      };
      const res = await addArticleKeyword(obj);
      if (res.data.code === 200) {
        this.tableData.map((item) => {
          if (item.id === row.id) {
            if (row.inputValue) {
              item.keywordList.push({
                id: res.data.data,
                name: row.inputValue,
              });
            }
            item.inputVisible = false;
            item.inputValue = "";
          }
        });
        this.$message.success(res.data.message || "新增成功");
      } else {
        this.$message.error(res.data.message || "新增失败");
      }
    },
    // 获取相同type的数组
    getSpanArr() {
      this.spanArr = [];
      for (let i = 0; i < this.tableData.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
          this.spanArr2.push(1);
          this.pos2 = 0;
        } else {
          // 判断当前元素与上一个元素的ID是否相同
          if (this.tableData[i].type === this.tableData[i - 1].type) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
          if (this.tableData[i].typeSub === this.tableData[i - 1].typeSub) {
            this.spanArr2[this.pos2] += 1;
            this.spanArr2.push(0);
          } else {
            this.spanArr2.push(1);
            this.pos2 = i;
          }
        }
      }
    },
    // 单元格合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 行列分组合并
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      // 行列分组合并
      if (columnIndex === 1) {
        const _row = this.spanArr2[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  position: relative;
  width: 100%;
  height: 100%;
}

.item {
  cursor: move;
  padding: 12px;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
  .box_62 {
    width: 16px;
    height: 16px;
    background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng76ab518d1128cec553e3d07026fb386be140900a9fb99b49d4dd6de5595b568c)
      100% no-repeat;
    background-size: 100% 100%;
  }
}
/*选中样式*/
.chosen {
  border: solid 2px #3089dc !important;
}

.tags {
  display: flex;
  flex-wrap: wrap;
}

.edit {
  width: 80px;
  height: 30px;
  line-height: 30px;
  margin: 10px 0;
  text-align: center;
  border: 1px solid #0d6ec4;
  border-radius: 4px;
  color: #0d6ec4;
  cursor: pointer;
}

/*里面的代码可以根据自己需求去进行更改*/
/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 12px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(0, 0, 0, 0.1);
}

.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
